import axios from "axios";

export const state = {
    requisitiondetails: [],
};

export const getters = {
    requisitiondetails: state => state.requisitiondetails,
};

export const mutations = {
    setRequisitiondetails(state, newValue) {
        state.requisitiondetails = newValue
    },
};

export const actions = {
    fetchRequisitiondetails({ commit }) {
        axios.get('/orderdetails').then(res => {
            // commit('setStoredetails', res.data.orderdetails)
            commit('setRequisitiondetails', res.data.orderdetails)

        })
    },
};
